import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

import LabTrackingModal from '../Dashboard/LabTrackingModal';
import TrackingModal from '../Dashboard/TrackingModal';
import Trackingmessage from '../Dashboard/Trackingmessage';
import LabTracking from '../Dashboard/LabTracking';

const OrderTracking = () => {
  const { clinicId, orderId } = useParams();
  const [orderData, setOrderData] = useState(null);
  const [orderStatus, setOrderStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusLoading, setStatusLoading] = useState(false);
  const [error, setError] = useState(null);
  const [trackingInfo, setTrackingInfo] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(''); // 'medicine' or 'lab'
  console.log('OrderTracking component rendered');
  console.log('useParams result:', useParams());
  console.log('clinicId from useParams:', clinicId);
  console.log('orderId from useParams:', orderId);
  console.log('Current URL:', window.location.pathname);
  
  // Fallback: extract clinicId and orderId from URL manually if useParams doesn't work
  const urlPath = window.location.pathname;
  const pathSegments = urlPath.split('/');
  const manualClinicId = pathSegments[pathSegments.length - 2]; // Second to last segment
  const manualOrderId = pathSegments[pathSegments.length - 1]; // Last segment
  console.log('Manual clinicId extraction:', manualClinicId);
  console.log('Manual orderId extraction:', manualOrderId);
  
  const finalClinicId = clinicId || manualClinicId;
  const finalOrderId = orderId || manualOrderId;
  console.log('Final clinicId to use:', finalClinicId);
  console.log('Final orderId to use:', finalOrderId);
  
  useEffect(() => {
    if (finalClinicId && finalOrderId) {
      fetchOrderDetails();
    } else {
      setError('Clinic ID or Order ID not found in URL');
      setLoading(false);
    }
  }, [finalClinicId, finalOrderId]);

  // Auto-call tracking when order data is available
  useEffect(() => {
    if (orderData?.patientDrugPrescriptionList?.drugOrderId) {
      // Medicine order - call medicine tracking
      handleMedicineTrackOrder(orderData.patientDrugPrescriptionList.drugOrderId);
    } else if (orderData?.patientLabTestsList?.labOrderId) {
      // Lab order - call lab tracking
      handleLabTrackOrder(orderData.patientLabTestsList.labOrderId);
    }
  }, [orderData]);

  const fetchOrderDetails = async () => {
    try {
      setLoading(true);
      const API_URL = process.env.REACT_APP_API_URL;
      
      console.log('Making API call with clinicId:', finalClinicId, 'and orderId:', finalOrderId);
      // Make API call to get order details
      const response = await axios.get(`${API_URL}orders/order-detail/${finalOrderId}`, {
        headers: {
          'tenantId': finalClinicId
        }
      });
      console.log('API response:', response.data.data);
      if (response.data && response.data.status === 200) {
        const orderData = response.data.data;
        console.log('orderData:', orderData.patientLabTestsList);
        // Check if patientDrugPrescriptionList exists
        if (orderData.patientDrugPrescriptionList) {
          console.log('patientDrugPrescriptionList found:', orderData.patientDrugPrescriptionList);
        }
        
        // Check if patientLabTestsList exists
        if (orderData.patientLabTestsList) {
          console.log('patientLabTestsList found:', orderData.patientLabTestsList);
          
        }
        
        setOrderData(orderData);
      } else {
        setError('Order not found');
      }
    } catch (error) {
      console.error('Error fetching order details:', error);
      setError('Failed to load order details');
    } finally {
      setLoading(false);
    }
  };

  // Helper function to process lab tracking response
  const processLabTrackingResponse = (data) => {
    // Sort status history by date (newest first)
    const sortedHistory = data.statusHistory?.sort(
      (a, b) => new Date(b.statusDate) - new Date(a.statusDate)
    ) || [];
    
    // Remove duplicate statuses (keep the latest occurrence)
    const uniqueHistory = sortedHistory.filter((status, index, array) => 
      array.findIndex(s => s.status === status.status) === index
    );
    
    return {
      ...data,
      statusHistory: uniqueHistory
    };
  };

  // Helper function to process medicine tracking response
  const processMedicineTrackingResponse = (data) => {
    // Sort status history by date (newest first)
    const sortedHistory = data.statusHistory?.sort(
      (a, b) => new Date(b.statusDate) - new Date(a.statusDate)
    ) || [];
    
    // Remove duplicate statuses (keep the latest occurrence)
    const uniqueHistory = sortedHistory.filter((status, index, array) => 
      array.findIndex(s => s.status === status.status) === index
    );
    
    return {
      ...data,
      statusHistory: uniqueHistory
    };
  };

  const handleLabTrackOrder = async (orderId) => {
    console.log("Track lab order clicked for orderId:", orderId);
    
    try {
      const API_NEW_URL = process.env.REACT_APP_API_NEW_URL;
      
      const response = await axios.get(
        `${API_NEW_URL}orderloader/order-status?orderNo=${orderId}`,
        {
          headers: {
            'tenantId': finalClinicId
          }
        }
      );

      console.log("Lab tracking API response:", response.data);
      
      // Check if response has the expected structure for lab orders
      if (response.data && response.data.orderNo) {
        // Process lab order response
        const processedData = processLabTrackingResponse(response.data);
        setTrackingInfo(processedData);
        setModalType('lab');
        setShowModal(true);
        console.log("Lab tracking modal should be open now");
      } else if (response.data && response.data.status === "OK") {
        // Handle case where API returns wrapped response
        const processedData = processLabTrackingResponse(response.data.data);
        setTrackingInfo(processedData);
        setModalType('lab');
        setShowModal(true);
        console.log("Lab tracking modal should be open now");
      } else if (response.data && response.data.message) {
        // Handle error response
        setTrackingInfo(response.data);
        setModalType('lab');
        setShowModal(true);
        console.log("Lab tracking modal opened with error message");
      } else {
        // This handles cases where API returns structured error response
        const errorMessage = response.data.message || "Failed to fetch lab tracking information";
        console.error("Lab tracking error:", errorMessage);
      }
    } catch (error) {
      // This handles network errors, server down, timeout, etc.
      console.error("Error fetching lab tracking data:", error);
      
      if (error.response?.status === 404) {
        console.error("Lab order not found");
      } else if (error.response?.status === 401) {
        console.error("Unauthorized access");
      } else {
        console.error("Failed to fetch lab tracking information");
      }
    }
  };

  const handleMedicineTrackOrder = async (orderId) => {
    console.log("Track medicine order clicked for orderId:", orderId);
    
    try {
      const API_NEW_URL = process.env.REACT_APP_API_NEW_URL;
      
      const response = await axios.get(
        `${API_NEW_URL}orderloader/order-status?orderNo=${orderId}`,
        {
          headers: {
            'tenantId': finalClinicId
          }
        }
      );

      console.log("Medicine tracking API response:", response.data);
      
      // Check if response has the expected structure for medicine orders
      if (response.data && response.data.orderNo) {
        // Process medicine order response
        const processedData = processMedicineTrackingResponse(response.data);
        setTrackingInfo(processedData);
        setModalType('medicine');
        setShowModal(true);
        console.log("Medicine tracking modal should be open now");
      } else if (response.data && response.data.status === "OK") {
        // Handle case where API returns wrapped response
        const processedData = processMedicineTrackingResponse(response.data.data);
        setTrackingInfo(processedData);
        setModalType('medicine');
        setShowModal(true);
        console.log("Medicine tracking modal should be open now");
      } else if (response.data && response.data.message) {
        // Handle error response
        setTrackingInfo(response.data);
        setModalType('medicine');
        setShowModal(true);
        console.log("Medicine tracking modal opened with error message");
      } else {
        // This handles cases where API returns structured error response
        const errorMessage = response.data.message || "Failed to fetch medicine tracking information";
        console.error("Medicine tracking error:", errorMessage);
      }
    } catch (error) {
      // This handles network errors, server down, timeout, etc.
      console.error("Error fetching medicine tracking data:", error);
      
      if (error.response?.status === 404) {
        console.error("Medicine order not found");
      } else if (error.response?.status === 401) {
        console.error("Unauthorized access");
      } else {
        console.error("Failed to fetch medicine tracking information");
      }
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'pending':
        return 'bg-yellow-100 text-yellow-800';
      case 'confirmed':
        return 'bg-blue-100 text-blue-800';
      case 'processing':
        return 'bg-purple-100 text-purple-800';
      case 'shipped':
        return 'bg-indigo-100 text-indigo-800';
      case 'delivered':
        return 'bg-green-100 text-green-800';
      case 'cancelled':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

 

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading order details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-6xl mb-4">❌</div>
          <h1 className="text-2xl font-bold text-gray-800 mb-2">Order Not Found</h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <p className="text-sm text-gray-500">Order ID: {finalOrderId}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <h1 className="sm:text-2xl text-lg font-bold text-gray-900">Order Tracking</h1>
        

        {modalType === 'lab' ? (
            <LabTracking
              trackingInfo={trackingInfo}
            />
          ) : (
            <Trackingmessage
             
              trackingInfo={trackingInfo}
              orderInfo={orderData}
            />
          )
        }
       

        {/* Prescription Items */}
        {orderData?.patientDrugPrescriptionList?.drugs && orderData.patientDrugPrescriptionList.drugs.length > 0 && (
          <div className="bg-white rounded-lg shadow-sm p-3 mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Prescription Items</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Drug Name
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Type
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Quantity
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Unit Price
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Discounted Price
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Total Amount
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {orderData.patientDrugPrescriptionList.drugs.map((drug, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{drug.drugName}</div>
                        {drug.drugCode && (
                          <div className="text-sm text-gray-500">Code: {drug.drugCode}</div>
                        )}
                        {drug.typeOfSell && (
                          <div className="text-sm text-gray-500">{drug.typeOfSell}</div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          drug.drugCategory === 'RX' ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
                        }`}>
                          {drug.drugCategory}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {drug.quantity}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        ₹{drug.rate}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        ₹{drug.discountedAmount || 0}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        ₹{drug.amount}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Order Items (fallback for non-prescription orders) */}
        {orderData?.items && orderData.items.length > 0 && !orderData?.patientDrugPrescriptionList && (
          <div className="bg-white rounded-lg shadow-sm p-6 mt-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Order Items</h3>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Item
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Quantity
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Price
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {orderData.items.map((item, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{item.name}</div>
                        {item.description && (
                          <div className="text-sm text-gray-500">{item.description}</div>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {item.quantity}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        ₹{item.price}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                        ₹{item.quantity * item.price}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            {/* Track Order Button */}
            <div className="mt-6 flex justify-center">
              <button
                className="bg-[#003F6B] hover:bg-[#002a4a] text-white px-6 py-2 rounded-lg text-sm font-medium transition-colors duration-200 shadow-sm"
                onClick={() => handleMedicineTrackOrder(orderData.patientDrugPrescriptionList.drugOrderId)}
              >
                Track Medicine Order
              </button>
            </div>
          </div>
        )}

        {/* Lab Test Items */}
        {orderData?.patientLabTestsList?.labTests && orderData.patientLabTestsList.labTests.length > 0 && (
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Lab Test Items</h3>
            <div className="mb-4">
              <div className="flex flex-col sm:flex-row sm:justify-between gap-2">
                <div>
                  <p className="text-sm text-gray-500">Lab Order ID</p>
                  <p className="font-mono text-lg font-semibold text-gray-900">
                    {orderData.patientLabTestsList.labOrderId}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Lab Type</p>
                  <p className="text-sm font-medium text-gray-900 capitalize">
                    {orderData.patientLabTestsList.labType}
                  </p>
                </div>
              </div>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Test Name
                    </th>
                    {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Lab Partner
                    </th> */}
                    {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Status
                    </th> */}
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Amount
                    </th>
                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                      Discounted Amount
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {orderData.patientLabTestsList.labTests.map((test, index) => (
                    <tr key={index}>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">{test.labTestName}</div>
                        {test.labTestId && (
                          <div className="text-sm text-gray-500">ID: {test.labTestId}</div>
                        )}
                      </td>
                      {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {test.labPartnerName || 'N/A'}
                      </td> */}
                      {/* <td className="px-6 py-4 whitespace-nowrap">
                        <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                          test.status === 1 ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                        }`}>
                          {test.status === 1 ? 'Active' : 'Inactive'}
                        </span>
                      </td> */}
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        ₹{test.amount}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        ₹{test.discountedAmount || 0}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
           
          </div>
        )} 

        {/* Tracking Timeline */}
        {orderData?.trackingHistory && orderData.trackingHistory.length > 0 && (
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Tracking Timeline</h3>
            <div className="flow-root">
              <ul className="-mb-8">
                {orderData.trackingHistory.map((event, index) => (
                  <li key={index}>
                    <div className="relative pb-8">
                      {index !== orderData.trackingHistory.length - 1 && (
                        <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
                      )}
                      <div className="relative flex space-x-3">
                        <div>
                          <span className="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center ring-8 ring-white">
                            <span className="text-white text-sm">✓</span>
                          </span>
                        </div>
                        <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
                          <div>
                            <p className="text-sm text-gray-500">{event.description}</p>
                          </div>
                          <div className="text-right text-sm whitespace-nowrap text-gray-500">
                            {new Date(event.timestamp).toLocaleString()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        )}

        {/* Tracking Message */}
        

        {/* Footer */}
        <div className="text-center mt-8 mb-6">
          <p className="text-sm text-gray-500">
            Need help? Contact our support team at{' '}
            <a href="mailto:support@curebay.com" className="text-blue-600 hover:text-blue-500">
              support@curebay.com
            </a>
          </p>
        </div>

       
      </div>
    </div>
  );
};

export default OrderTracking;
